<template>
	<div v-loading="loading">
		<el-space :spacer="spacer" :size="4">
			<span>Data Status Orang Tua</span>
			<el-tooltip content="Tambah data">
				<el-button type="info" size="small" icon="Plus" plain round @click="dialogCreateVisible = true" />
			</el-tooltip>
		</el-space>
		<hr />
		<el-table :data="tableData" row-key="status_ortu_id">
			<el-table-column type="index" label="No." />
			<el-table-column label="Status" prop="deskripsi">
				<template #default="{ row }">
					<transition name="fade" mode="out-in">
						<span :key="row.deskripsi">{{ row.deskripsi }}</span>
					</transition>
				</template>
			</el-table-column>
			<el-table-column label="Bagian harus diisi" prop="required_fields_count">
				<template #default="{ row }">
					<transition name="fade" mode="out-in">
						<span :key="row.required_fields_count">{{ row.required_fields_count }}</span>
					</transition>
				</template>
			</el-table-column>
			<el-table-column label="Diperbarui" prop="last_update">
				<template #default="{ row }">
					<transition name="fade" mode="out-in">
						<span :key="row.last_update">{{ row.last_update }}</span>
					</transition>
				</template>
			</el-table-column>
			<el-table-column label="Tindakan">
				<template #default="{ row }">
					<transition name="fade" mode="out-in">
						<el-space :spacer="spacer" :size="2">
							<el-tooltip content="Edit data">
								<el-button type="primary" size="small" icon="Edit" plain round @click="edit(row)" />
							</el-tooltip>
							<el-tooltip content="Hapus data">
								<el-button type="danger" size="small" icon="Delete" plain round :loading="deleting === row" @click="confirmDelete(row)" />
							</el-tooltip>
						</el-space>
					</transition>
				</template>
			</el-table-column>
		</el-table>
		<el-form :model="formCreate" :rules="rules" ref="formCreate" label-width="auto" @submit.prevent="insertData" :disabled="inserting">
			<el-dialog v-model="dialogCreateVisible" :close-on-click-modal="false" :close-on-press-escape="false" title="Tambah Data" align-center width="85%">
				<el-row :gutter="10">
					<el-col :xs="24" :md="12" :xl="8">
						<el-form-item label="Deskripsi status" prop="deskripsi">
							<el-input v-model="formCreate.deskripsi" placeholder="Deskripsi status" />
						</el-form-item>
					</el-col>

					<el-divider content-position="left">Status bagian data orang tua</el-divider>
					<el-col :xs="24" :sm="12" :lg="8" :xl="6" v-for="[key, val] of Object.entries(descriptions)" :key="key">
						<el-form-item :label="val" :prop="key">
							<el-switch v-model="formCreate.fields[key]" size="small" active-text="Harus" inactive-text="Opsional" />
						</el-form-item>
					</el-col>
				</el-row>
				<template #footer>
					<el-button type="info" plain @click="dialogCreateVisible = false">Batal</el-button>
					<el-button type="success" native-type="submit" :loading="inserting">Simpan</el-button>
				</template>
			</el-dialog>
		</el-form>
		<el-form :model="formEdit" ref="formEdit" label-width="auto" @submit.prevent="updateData" :disabled="loadingEdit">
			<el-dialog v-model="dialogEditVisible" :close-on-click-modal="false" :close-on-press-escape="false" title="Edit Data" align-center width="85%">
				<el-row :gutter="10">
					<el-col :xs="24" :md="12" :xl="8">
						<el-form-item label="Deskripsi status" prop="deskripsi">
							<el-input v-model="formEdit.deskripsi" :placeholder="editing?.deskripsi || 'Deskripsi status'" />
						</el-form-item>
					</el-col>

					<el-divider content-position="left">Status bagian data orang tua</el-divider>
					<el-col :xs="24" :sm="12" :lg="8" :xl="6" v-for="[key, val] of Object.entries(descriptions)" :key="key">
						<el-form-item :label="val" :prop="key">
							<el-switch v-model="formEdit.fields[key]" size="small" active-text="Harus" inactive-text="Opsional" />
						</el-form-item>
					</el-col>
				</el-row>
				<template #footer>
					<el-button type="info" plain @click="dialogEditVisible = false">Batal</el-button>
					<el-button type="success" native-type="submit" :loading="loadingEdit">Simpan</el-button>
				</template>
			</el-dialog>
		</el-form>
	</div>
</template>

<script>
import { ElDivider } from "element-plus";
import { h } from "vue";
export default {
	name: "StatusOrtu",
	data() {
		return {
			spacer: h(ElDivider, { direction: "vertical" }),
			dialogCreateVisible: false,
			formCreate: {
				deskripsi: null,
				fields: {
					status_ortu_id: false,
					nama: false,
					nik: false,
					tahun_lahir: false,
					tahun_wafat: false,
					pendidikan_id: false,
					pekerjaan_id: false,
					penghasilan_id: false,
					berkebutuhan_khusus_id: false,
					kontak: false,
					alamat_sama: false,
					alamat: false,
					rt: false,
					rw: false,
					desa: false,
					kecamatan: false,
					kabupaten_kota: false,
					provinsi: false,
					foto_ktp: false,
					catatan: false,
				},
			},
			rules: {
				deskripsi: [{ required: true, message: "Masukkan deskripsi status orang tua", trigger: "change" }],
			},
			originalFields: null,
			dialogEditVisible: false,
			formEdit: {
				deskripsi: null,
				fields: {},
			},
			inserting: false,
			editing: null,
			loadingEdit: false,
			deleting: null,
			descriptions: {
				status_ortu_id: "Status Orang Tua",
				nama: "Nama",
				nik: "Nomor Induk Kependudukan",
				tahun_lahir: "Tahun Lahir",
				tahun_wafat: "Tahun Wafat",
				pendidikan_id: "Pendidikan Terakhir",
				pekerjaan_id: "Pekerjaan",
				penghasilan_id: "Rentang Penghasilan",
				berkebutuhan_khusus_id: "Jenis Kebutuhan Khusus",
				kontak: "Kontak",
				alamat_sama: "Alamat sama dengan siswa?",
				alamat: "Alamat",
				rt: "RT",
				rw: "RW",
				desa: "Desa",
				kecamatan: "Kecamatan",
				kabupaten_kota: "Kabupaten/Kota",
				provinsi: "Provinsi",
				foto_ktp: "Foto KTP",
				catatan: "Catatan",
			},
		};
	},
	props: {
		dataPendukung: Object,
		loadingData: Object,
		updateEditing: Function,
		modalWidth: String,
	},
	computed: {
		tableData() {
			return this.dataPendukung["status_ortu"];
		},
		loading() {
			return this.loadingData["status_ortu"];
		},
		formChanged() {
			return this.formEdit.deskripsi || (this.originalFields && this.originalFields !== JSON.stringify(this.formEdit.fields));
		},
	},
	watch: {
		formChanged(val) {
			if (val) this.updateEditing(true);
			else this.updateEditing(false);
		},
		dialogCreateVisible() {
			this.$refs.formCreate.resetFields();
		},
		editing(val) {
			if (!val) {
				this.dialogEditVisible = false;
				return;
			}

			this.dialogEditVisible = true;
			const tmp = {};
			const oldData = this.tableData.find((t) => t.status_ortu_id === val.status_ortu_id);
			if (!oldData) return;

			const fields = oldData.fields || [];

			fields.forEach((f) => {
				tmp[f.col] = f.is_required;
			});

			this.originalFields = JSON.stringify(tmp);
			this.formEdit.fields = tmp;
		},
		dialogEditVisible(val) {
			if (!val) {
				this.$refs.formEdit.resetFields();
				this.originalFields = null;
				this.editing = null;
			}
		},
	},
	mounted() {},
	beforeUnmount() {},
	beforeRouteLeave(to, from, next) {
		if (this.formChanged) {
			const answer = window.confirm("Perubahan belum disimpan. Apakah Anda yakin ingin meninggalkan halaman ini?");
			if (answer) {
				this.updateEditing(false);
				next();
			} else {
				next(false);
			}
		} else {
			next();
		}
	},
	methods: {
		edit(row = null) {
			if (row) this.editing = row;
			else this.editing = null;
		},
		confirmDelete(row) {
			this.$confirm("", "Perhatian", {
				message: h("div", {}, ["Anda yakin ingin menghapus status ", h("mark", { class: "fw-bold" }, row.deskripsi), "?"]),
				confirmButtonText: "Ya, hapus",
				cancelButtonText: "Batal",
				type: "warning",
			})
				.then(() => this.deleteData(row))
				.catch(() => {});
		},
		async insertData() {
			this.inserting = true;
			try {
				const valid = await this.$refs.formCreate.validate((res) => {
					return res;
				});
				if (!valid) {
					throw Error("Silakan masukkan isian sesuai dengan ketentuan");
				}

				const fields_to_add = [];
				Object.entries(this.formCreate.fields).forEach(([key, val]) => {
					if (val) fields_to_add.push(key);
				});
				const { data } = await this.$defaultApi.post("/data/status-ortu/create", {
					deskripsi: this.formCreate.deskripsi,
					fields_to_add,
				});

				this.dialogCreateVisible = false;
				this.$notify.success({
					title: "Berhasil",
					message: data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.inserting = false;
				}, 500);
			}
		},
		async updateData() {
			this.loadingEdit = true;
			try {
				if (!this.formEdit.deskripsi && this.originalFields === JSON.stringify(this.formEdit.fields)) {
					throw Error("Belum ada perubahan");
				}

				const dels = [];
				const adds = [];

				const oldFields = JSON.parse(this.originalFields);
				Object.entries(this.formEdit.fields).forEach(([key, val]) => {
					if (oldFields[key] === true && val === false) dels.push(key);
					if (oldFields[key] === false && val === true) adds.push(key);
				});

				const { data } = await this.$defaultApi.post("/data/status-ortu/update", {
					status_ortu_id: this.editing.status_ortu_id,
					deskripsi: this.formEdit.deskripsi,
					fields_to_del: dels,
					fields_to_add: adds,
				});

				this.editing = null;
				this.$notify.success({
					title: "Berhasil",
					message: data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.loadingEdit = false;
				}, 500);
			}
		},
		async deleteData(row) {
			this.deleting = row;
			try {
				const { data } = await this.$defaultApi.post("/data/status-ortu/delete", {
					status_ortu_id: row.status_ortu_id,
				});

				this.$notify.success({
					title: "Berhasil",
					message: data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.deleting = null;
				}, 500);
			}
		},
	},
};
</script>

<style scoped></style>
